import React, { useState } from 'react';
import { Box } from '@mui/material';

import { InputFieldV2 } from 'components/common/form-controls';
import { serviceVehiclesServices } from '@services';
import { showError } from '@utils';

import styles from './slotsList.style';

const SlotsList = ({
  slots,
  serviceVehicleId,
  getServiceVehicle,
  disableActions,
}) => {
  const [loading, setLoading] = useState(false);

  const handleSelect = async (slot) => {
    try {
      setLoading(true);

      await serviceVehiclesServices.postServiceVehiclesSelectedSlot(
        serviceVehicleId,
        {
          slotId: `${slot?.vendor}.${slot?.date}.${slot?.time}`,
        }
      );
      getServiceVehicle();
    } catch (error) {
      showError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={styles.list}>
      {slots?.map((slot) => {
        return (
          <Box
            key={`${slot?.vendor}-${slot?.date}-${slot?.time}`}
            sx={styles.checkBoxWrapper}
          >
            <InputFieldV2
              type="radio"
              value={slot?.isSelected}
              onChange={() => {
                handleSelect(slot);
              }}
              disabled={loading || disableActions}
            />
            <Box sx={styles.text}>
              <Box
                skeletonProps={{
                  sx: {
                    maxWidth: '90px',
                  },
                }}
                loading={loading}
              >
                {slot?.date}
              </Box>
              <Box
                skeletonProps={{
                  sx: {
                    maxWidth: '90px',
                  },
                }}
                loading={loading}
              >
                {slot?.time}
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

const memoizedSlotsList = React.memo(SlotsList);
export { memoizedSlotsList as SlotsList };

export default memoizedSlotsList;
